import { render, staticRenderFns } from "./ImsInventoryHoldingList.vue?vue&type=template&id=a6a7e622&"
import script from "./ImsInventoryHoldingList.vue?vue&type=script&lang=js&"
export * from "./ImsInventoryHoldingList.vue?vue&type=script&lang=js&"
import style0 from "./ImsInventoryHoldingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports